import store from "@/store/index";

// Fakturownia runs one invoicing service under a brand per country (the vendor's country list on
// bitfactura.com). The integration talks to the account address the tenant saved, whichever brand it is,
// so texts name the brand of that address; without one they name the brand of the panel language.
const HOST_BRANDS = [
  [".fakturownia.pl", "Fakturownia"],
  [".invoiceocean.com", "InvoiceOcean"],
  [".invoiceocean.hr", "InvoiceOcean"],
  [".invoiceocean.rs", "InvoiceOcean"],
  [".efakturierung.de", "eFakturierung"],
  [".vosfactures.fr", "VosFactures"],
  [".bitfactura.com", "BitFactura"],
  [".bitfactura.es", "BitFactura"],
  [".bitfaktura.sk", "BitFaktura"],
  [".bitfaktura.cz", "BitFaktura"],
  [".bitfaktura.com.ua", "BitFaktura"],
];

const LANGUAGE_BRANDS = {
  pl: "Fakturownia",
  en: "InvoiceOcean",
  de: "eFakturierung",
  es: "BitFactura",
  fr: "VosFactures",
};

export const INVOICING_BRAND_ATTRIBUTE = "@{invoicing}";

// Addresses saved before the API required https may lack the scheme.
export function brandOfAccountUrl(accountUrl) {
  if (!accountUrl) {
    return null;
  }

  let host;
  try {
    const address = String(accountUrl).trim();
    host = new URL(
      address.includes("://") ? address : `https://${address}`,
    ).hostname.toLowerCase();
  } catch (e) {
    return null;
  }

  const match = HOST_BRANDS.find(
    ([suffix]) => host.length > suffix.length && host.endsWith(suffix),
  );

  return match ? match[1] : null;
}

export function invoicingBrand(accountUrl, language) {
  return (
    brandOfAccountUrl(accountUrl) ||
    LANGUAGE_BRANDS[language] ||
    LANGUAGE_BRANDS.en
  );
}

function connectedAccountUrl() {
  const plan = store.getters["packages/getCurrentTenantPlan"];
  const invoicing = (plan?.tenant_packages || []).find(
    (tenantPackage) => tenantPackage.package?.service?.slug === "fakturownia",
  );

  return invoicing?.config?.account_url || null;
}

// The language the texts were loaded in; the store's locale holds regional settings, not this.
function panelLanguage() {
  return (document.documentElement.lang || "en").slice(0, 2).toLowerCase();
}

export function fillInvoicingBrand(text) {
  if (!text.includes(INVOICING_BRAND_ATTRIBUTE)) {
    return text;
  }

  return text
    .split(INVOICING_BRAND_ATTRIBUTE)
    .join(invoicingBrand(connectedAccountUrl(), panelLanguage()));
}
